import defaultUrl from './urls.js';
let urls = {
    // 微信登录
    wxLogin: 'api/config/wxconfig',
    // 获取用户信息
    userInfo: 'api/wxuser/me',
    // 获取别人的用户信息
    otherUserInfo: 'api/wxuser/userdetail',
    // 获取用户二维码
    userQrcode: 'api/wxuser/userqrcode',
    // 栏目目录(树形结构)
    columnList: 'api/column/list',
    // 全部的栏目目录
    allColumnList: 'api/produce/columnlist',
    // 首页推荐栏目
    homeRecommendColumns: 'api/column/shareindexlist',
    // 文章列表
    articleList: 'api/articles/list',
    // 文章详情
    articleDetail: 'api/articles/detail',
    // 相关文章推荐
    relevantArticles: 'api/articles/relevant',
    // 栏目广告位文章
    advArticleList: 'api/articles/advertise',
    // 转发推荐列表(带广告)
    forwardRecommend: 'api/articles/forwardrecommend',
    // 文章标签列表
    articleLabelList: 'api/article/getlabels',
    // 添加文章标签
    addArticleLabel: 'api/article/addlabel',
    // 栏目的托管公众号
    mpwxTrusteeshipList: 'api/officialaccount/trusteeship',
    // 文章收藏
    articleCollection: 'api/user/favorite',
    // 文章点赞
    articleLike: 'api/user/like',
    // 发表评论
    publishComment: 'api/user/comment',
    // 文章评论列表
    commentList: 'api/articles/articlecomment',
    // 文章评论详情
    commentDetail: 'api/articles/commentdetail',
    // 文章评论点赞
    conmmentLike: 'api/user/conmmentlike',
    // 生成文章key
    articleKey: 'api/articles/createkey',
    // 转发成功后执行的回调
    wxForWard: 'api/articles/wxforward',
    // 用户的评论列表
    userCommentList: 'api/user/commentlist',
    // 用户的转发列表
    userForwardlist: 'api/user/forwardlist',
    // 用户的转发汇总数据
    userForwardData: 'api/user/getforward',
    // 用户的收藏列表
    userFavoritelist: 'api/user/favoritelist',
    // 用户的点赞列表
    userLikelist: 'api/user/likelist',
    // 用户的文章列表
    userArticleList: 'api/user/myarticles',
    // 用户的视频列表
    userVideolist: 'api/user/myvideolist',
    // 主页-我的动态
    userNewDynamic: 'api/user/mydynamic',
    // 24小时文件夹列表
    timerFolderList: 'api/produce/twentyfour',
    // 主页-我的24小时
    userMineHours: 'api/produce/twentyfourarticles',
    // 24小时新增文件夹
    newTimerFolder: 'api/produce/setdaydynamic',
    // 24小时编辑文件夹
    editTimerFolder: 'api/produce/daydynamicfolderedit',
    // 24小时删除文件夹
    deleteTimerFolder: 'api/user/deletedaydynamicfolder',
    // 24小时中已关注的栏目
    hoursColumnList: 'api/user/getdaycolumn',
    // 账号管理-用户信息修改
    userInfoEdit: 'api/wxuser/updateuser',
    // 个人中心-我的粉丝
    userFansList: 'api/user/myfans',
    // 潜在粉丝
    potentialFans: 'api/produce/potentialfans',
    // 用户关注/取消关注
    userFollow: 'api/user/follow',
    // 个人中心-我的关注
    userFollowList: 'api/user/myfollow',
    // 关注公众号栏目
    followColumn: 'api/produce/followcolumn',
    // 取消关注公众号栏目
    unFollowColumn: 'api/produce/unfollowcolumn',
    // 关注托管公众号栏目
    followMpwxColumn: 'api/officialaccount/follow',
    // 公众号栏目文章
    columnArticles: 'api/produce/columnarticle',
    // 个人中心-我的收藏-收藏夹列表
    userCollectionFolders: 'api/user/mycollectionfolder',
    // 个人中心-我的收藏-新增收藏夹
    userAddFolder: 'api/user/addcollectionfolder',
    // 个人中心-我的收藏-编辑收藏夹
    userEditFolder: 'api/produce/articlefolderedit',
    // 个人中心-我的收藏-编辑收藏夹
    userDeleteFolder: 'api/user/deletecollection',
    // 个人中心-我的收藏-收藏列表
    userCollectionList: 'api/user/mycollection',
    // 个人中心-我的收藏-删除收藏
    userDeleteCollection: 'api/user/deletecollection',
    // 个人中心-我的收藏-删除收藏文章
    userDeleteCollectionArticle: 'api/user/deletecollectionarticles',
    // 个人中心-我的消息-我的评论
    userMyCommentList: 'api/user/mycomment',
    // 个人中心-我的消息-系统通知
    userSyatemNoticeList: 'api/produce/systemlogs',
    // 个人中心-我的消息-系统通知-处理操作
    userNoticeConfirm: 'api/produce/confirm',
    // 采集微信公众号文章
    quoteWxArticle: 'api/articles/collection',
    // 保存到草稿
    saveDrafts: 'api/articles/drafts',
    // 草稿箱文章列表
    draftsArticles: 'api/articles/draftslist',
    // 草稿箱文章详情
    draftsArticleDetail: 'api/articles/draftsdetail',
    // 草稿箱文章编辑
    draftsArticleEdit: 'api/articles/draftsedit',
    // 删除草稿
    deleteDrafts: 'api/articles/draftsdel',
    // 发布文章
    sendArticle: 'api/articles/publisharticle',
    // 投稿/内容管理-文章编辑
    userArticleEdit: 'api/produce/editarticle',
    // 内容管理-文章详情
    userArticleDetail: 'api/produce/myarticlesdetail',
    // 原创文件夹列表
    selfFolderList: 'api/produce/folderlist',
    // 新建原创文件夹
    newAddSelfFolder: 'api/produce/articlefolder',
    // 编辑原创文件夹
    editSelfFolder: 'api/produce/editfolder',
    // 删除原创文件夹
    deleteSelfFolder: 'api/produce/deletefolder',
    // 原创文件夹文章列表
    selfArticleList: 'api/produce/originalarticles',
    // 保存原创文章
    saveSelfArticle: 'api/produce/articlesave',
    // 角色列表
    roleList: 'api/produce/rolelist',
    // 申请角色
    roleApply: 'api/produce/apply',
    // 申请角色的栏目列表
    applyColumnList: 'api/produce/getapplycolumn',
    // 申请角色详情
    applyRoleDetail: 'api/produce/applydetail',
    // 申请角色编辑
    applyRoleEdit: 'api/produce/applyedit',
    // 申请角色撤销
    applyRoleCancel: 'api/produce/applycancel',
    // 申请通过的栏目
    applyPassColumn: 'api/produce/getpasscolumn',
    // 审核文章列表
    auditArticleList: 'api/produce/articlechecklist',
    // 文章审核
    auditArticle: 'api/produce/articlecheck',
    // 公众号授权申请
    mpwxApply: 'api/officialaccount/apply',
    // 公众号授权-已托管的公众号
    mpwxMyApply: 'api/officialaccount/myapply',
    // 公众号授权-已托管的公众号-修改申请
    mpwxMyApplyEdit: 'api/officialaccount/edit',
    // 公众号授权-已托管的公众号-撤销
    mpwxMyApplyCancel: 'api/officialaccount/cancel',
    // 公众号授权-已托管的公众号-查看数据
    mpwxMyApplyLook: 'api/officialaccount/show',
    // 公众号授权-已托管的公众号-查看数据-列表数据(文章列表/粉丝列表)
    mpwxListData: 'api/officialaccount/getcolumndata',
    // 文章管理列表
    articlesManage: 'api/produce/myarticlesmanage',
    // 文章管理-撤回文章
    withdrawArticle: 'api/produce/withdraw',
    // 文章管理-移至草稿
    moveToDrafts: 'api/produce/articledrafts',
    // 文章管理-删除文章
    deleteArticles: 'api/produce/articledelete',
    // 我的转发列表
    forwardList: 'api/produce/myforwardlist',
    // 我的转发删除
    forwardDelete: 'api/user/hideforward',
    // 推荐转发列表
    recommendForwardList: 'api/produce/recommendforwardlist',
    // 一级转发列表
    fristForwardList: 'api/produce/oneforward',
    // 二级转发列表
    secondForwardList: 'api/produce/secondforward',
    // 一级的二级转发(子级的子级)
    grandsonForwardList: 'api/produce/onetotwoforward',
    // 用户的转发列表
    otherForwardList: 'api/produce/userforwardlist',
    // 佣金列表
    myBrokerageMoneyList: 'api/user/getcommissionorders',
    // 成交金额列表
    bargainMoneyList: 'api/user/getcommission',
    // 成交金额列表-一级列表
    oneBargainMoneyList: 'api/user/getcommissionone',
    // 成交金额列表-二级列表
    twoBargainMoneyList: 'api/user/getcommissionsecond',
    // 佣金详情
    commissionDetail: 'api/user/commissiondetail',
    // 我的消息列表
    myMessageList: 'api/produce/newslogslist',
    // 回复消息/发消息
    replyMessage: 'api/produce/addnewslogs',
    // 聊天记录
    chatRecords: 'api/produce/usernews',
    // 聊天记录删除
    chatRecordDelete: 'api/user/chatmessagedelete',
    // 系统通知
    systemNoticeList: 'api/produce/systemlogs',
    // 删除系统消息
    systemNoticeDelete: 'api/produce/deletemessage',
    // 申请提现
    applyWithdraw: 'api/produce/withdrawal',
    // 提现记录
    withdrawList: 'api/produce/withdrawlist',
    // 提现详情
    withdrawDetail: 'api/produce/withdrawaldetail',
    // 小程序-商品列表-凤凰社
    goodsList: 'api/mchcate/categoodslist',
    fhsGoodsList: 'api/store/goodslist',
    // 小程序-楼层导航列表-凤凰社
    levelList: 'api/store/floors',
    // 小程序-楼层商家列表-凤凰社
    levelShopList: 'api/store/floorstores',
    fhsLevelShopList: 'api/store/floorstores',
    // 小程序-商品列表-卓悦汇
    zyhGoodsList: 'api/store/zhuoyuegoodslist',
    // 小程序-楼层导航列表-卓悦汇
    zyhFloorList: 'api/store/zhuoyuefloors',
    // 小程序-楼层商家列表-卓悦汇
    zyhLevelShopList: 'api/store/zhuoyuefloorstores',
    // 小程序-到店巨惠列表-卓悦汇
    zyhOnsiteList: 'api/advertisement/zhuoyueonsitestoregoods',
    // 小程序-爆款促销列表-卓悦汇
    zyhHotPromotionList: 'api/advertisement/zhuoyuepromotionstoregoods',
    // 小程序-商品分类列表-卓悦汇
    zyhGoodsTypeList: 'api/advertisement/zhuoyuegoodscate',
    // 小程序-获取分类商品-卓悦汇
    zyhTypeGoodsList: 'api/store/getcategoods',
    // 小程序-商品列表-米链优选
    mlyxGoodsList: 'api/store/miliangoodslist',
    // 小程序-楼层商家列表-米链优选
    mlyxLevelShopList: 'api/store/zhuoyuefloorstores',
    // 商品二维码
    goodsQrcode: 'api/advertisement/goods_qrcode',
    // 商品详情
    goodsDetail: 'api/advertisement/goodsdetail',
    // 单图片上传
    configImage: 'api/config/image',
    // 视频上传
    configVideo: 'api/config/video',
    // 搜索
    searchData: 'api/search/index',
    // 获取上传token
    getUpToken: 'api/config/qiniutoken',
    // 文章图片本地化
    imagesLocal: 'api/articles/imageslocal',
};
Object.keys(urls).forEach(el => {
    urls[el] = defaultUrl + urls[el];
});
export default urls;


// WEBPACK FOOTER //
// ./src/ws/api.js